let config = {}

if (window.trinyConfig) {
  config = {
    logged: window.trinyConfig.customer.logged
  }
}

export const trinyConfig = config



// WEBPACK FOOTER //
// ./src/config/trinyConfig.js